import { IFORM } from 'featureLib';
import { TYPEOF_ORDER } from 'common/constants/app.constants';

const getRequestType = (formSchema: IFORM) => {
  const selectedTypeOfOrder = formSchema['typeOfOrder'].value?.key;

  let orderType = selectedTypeOfOrder;
  let orderSubType = selectedTypeOfOrder;

  if (selectedTypeOfOrder === TYPEOF_ORDER.UPGRADE || selectedTypeOfOrder === TYPEOF_ORDER.SHIFTING) {
    orderType = 'CHANGE_ORDER';
  }

  if (selectedTypeOfOrder === TYPEOF_ORDER.NEW_PRE_ORDER) {
    orderType = 'PRE_ORDER';
    orderSubType = TYPEOF_ORDER.NEW;
  }

  if (selectedTypeOfOrder === TYPEOF_ORDER.UPGRADE_PRE_ORDER) {
    orderType = 'PRE_ORDER';
    orderSubType = TYPEOF_ORDER.UPGRADE;
  }

  return {
    orderType,
    orderSubType
  };
};

export const prepareCreateLeadPayload = (formSchema: IFORM) => {
  const request = {} as any;

  request['partyId'] = formSchema['selectedAccount'].value?.partyId;
  request['product'] = formSchema['productType'].value?.key;
  // request['typeOfOrder'] = formSchema['typeOfOrder'].value?.key;
  request['orderNickName'] = formSchema['orderNickName'].value;
  request['journeyType'] = formSchema['siteType'].value?.id;
  request['customerName'] = formSchema['fullName'].value;
  request['phoneNumber'] = formSchema['phoneNumber'].value;
  request['email'] = formSchema['emailAddress'].value;
  request['orderType'] = getRequestType(formSchema).orderType;
  request['orderSubType'] = getRequestType(formSchema).orderSubType;

  if (formSchema['typeOfOrder'].value?.key === TYPEOF_ORDER.NEW_PRE_ORDER || formSchema['typeOfOrder'].value?.key === TYPEOF_ORDER.UPGRADE_PRE_ORDER) {
    request['loiAvailable'] = formSchema['loiAvailable'].value;
  }

  return request;
};
